import React, { Fragment } from 'react';
import { CommonInput, CommonSelect } from '../../../..';
import {
  ruleName,
  expandIcon,
  divWrapper,
  ruleContainer
} from './BreKyc.module.css';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import Tooltip from '@material-ui/core/Tooltip';
import KYCSaveAndUpdateButton from './KYCSaveAndUpdateButton';
const UpdateOrAddComponent = ({
  values,
  errors,
  touched,
  setFieldValue,
  handleBlur,
  isSubmitting,
  handleSubmit,
  setFieldTouched,
  handleResetForm,
  doc1forName,
  doc1forDob,
  selectStyles,
  showingFullDiv,
  toggleFeatue,
  setToggleFeature,
  mobile,
  rule,
  data,
  setShowFullDiv
}) => {
  return (
    <Fragment>
      <p
        className={` ${ruleName} capitalize text-lg font-open-sans-bold md:font-open-sans-semi-bold}`}
      >
        {rule}
        <span
          onClick={() => {
            setShowFullDiv(e => !e);
            if (typeof setToggleFeature == 'function') setToggleFeature(rule);
          }}
          className={`ml-auto float-right cursor-pointer ${
            toggleFeatue != rule ? divWrapper : expandIcon
          }`}
        >
          {mobile ? (
            toggleFeatue != rule && <ExpandMoreIcon />
          ) : (
            <ExpandMoreIcon />
          )}
        </span>
        {data?.id && (
          <span
            onClick={handleResetForm}
            className={`ml-auto float-right cursor-pointer`}
          >
            <Tooltip title="Reset" arrow>
              <RotateLeftIcon />
            </Tooltip>
          </span>
        )}
      </p>
      <div
        className={`w-full grid md:grid-cols-3  xmd:flex  gap-3 items-center text-center mt-5 ${ruleContainer}`}
      >
        <CommonSelect
          sort={true}
          name="doc1"
          value={values?.doc1}
          onChange={e => {
            setFieldValue('doc1', {
              value: e.value,
              label: e.label
            });
            setFieldTouched('doc1', true, false);
          }}
          onBlur={() => {
            setFieldTouched('doc2', true, true);
          }}
          options={doc1forName}
          isHoverEffect
          {...selectStyles}
          error={touched?.doc1 && errors.doc1}
          touched={touched.doc1}
          errorMsg={errors?.doc1?.value}
        />
        <p className="text-black-whatsAppUnReadMessage font-open-sans-semi-bold md:font-open-sans text-sm px-3 text-left md:text-center">
          Matches
        </p>
        <CommonSelect
          sort={true}
          name="doc2"
          value={values?.doc2}
          onChange={e => {
            setFieldValue('doc2', {
              value: e.value,
              label: e.label
            });
            setFieldTouched('doc2', true, false);
          }}
          onBlur={() => {
            setFieldTouched('doc2', true, true);
          }}
          options={doc1forDob}
          isHoverEffect
          {...selectStyles}
          error={touched?.doc2 && errors.doc2}
          touched={touched.doc2}
          errorMsg={errors?.doc2?.value}
        />
        <div className="w-full mt-3 md:mt-0">
          <CommonInput
            name="percentage"
            onChange={e => {
              let v = e?.target?.value;
              if (isNaN(v) || v > 100) return;
              setFieldValue('percentage', parseInt(v) || '0');
            }}
            onBlur={handleBlur}
            value={values.percentage}
            stylesContainer={{
              height: '52px',
              width: '100%',
              minWidth: '112px',
              maxWidth: '100%'
            }}
            legendName="Percentage"
            error={touched.percentage && errors.percentage}
            errorMsg={errors.percentage}
            touched={touched.percentage}
          />
        </div>
        <div
          className="block md:hidden fixed bottom-0 justify-self-center w-10/12"
          style={{ bottom: '5px' }}
        >
          {toggleFeatue == rule && (
            <KYCSaveAndUpdateButton
              handleSubmit={handleSubmit}
              data={data}
              isSubmitting={isSubmitting}
            />
          )}
        </div>
        <div className="md:block hidden">
          <KYCSaveAndUpdateButton
            handleSubmit={handleSubmit}
            data={data}
            isSubmitting={isSubmitting}
          />
        </div>
      </div>
    </Fragment>
  );
};

export default UpdateOrAddComponent;
